import styled from 'styled-components/macro';

export const StyledSponsorsSidebar = styled.div`
  .sponsors-title {
    color: ${(props) => props.theme.fontColor.primary};
    font-size: 1.5rem;
    font-weight: 700;
    border-bottom: 1px solid ${(props) => props.theme.grey.light};
    margin-bottom: 1rem;
    padding: 0 1.5rem 1.5rem;
  }
  .sponsors-content {
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px;
    margin-right: 10px;
  }
  .sponsors-item {
    &-pic {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        max-width: 100%;
      }
    }
    &-title {
      font-size: 1.1rem;
      font-weight: 600;
      color: ${(props) => props.theme.fontColor.primary};
      line-height: 1.4rem;
      text-align: center;
      margin-top: 1rem;
    }
  }
`;
